import { Skeleton } from '@mui/material'
import { ICellRendererParams } from 'ag-grid-community'
import clsx from 'clsx'
import { AssetInformationModal, LinkButton } from 'components/core-v2'
import React, { useState } from 'react'

import { ReconciliationTableRowData } from '../reconciliation-utilities/map-data'
import classes from './asset-name-cell.module.scss'

export const AssetNameLoadingCell = () => (
  <div className={clsx(classes.loadingCell)}>
    <Skeleton className="mb-1" height="15px" variant="rectangular" width="240px" />
    <Skeleton height="15px" variant="rectangular" width="140px" />
  </div>
)

export const AssetNameCell = ({ data }: ICellRendererParams<ReconciliationTableRowData>) => {
  const [showModal, setShowModal] = useState(false)
  return (
    <span className={classes.cell}>
      <LinkButton underline onClick={() => setShowModal(true)}>
        {data.assetName}
      </LinkButton>
      <span>{data.assetId}</span>
      <AssetInformationModal
        assetId={data.assetId}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </span>
  )
}
